import React, { createContext, useContext, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import type { UseFormReturn, FieldValues, DefaultValues } from 'react-hook-form';

export type GoalFormContextValue =
  | (UseFormReturn<FieldValues> & { loading?: boolean })
  | null;

const GoalFormContext = createContext<GoalFormContextValue>(null);

export const useGoalForm = (): UseFormReturn<FieldValues> & { loading?: boolean } => {
  const ctx = useContext(GoalFormContext);

  if (!ctx) {
    throw new Error('useGoalForm must be used within a GoalFormProvider');
  }

  return ctx;
};

interface GoalFormProviderProps {
  children: React.ReactNode;
  defaultValues: DefaultValues<FieldValues>;
  loading?: boolean;
}

export const GoalFormProvider = ({
  children,
  defaultValues,
  loading,
}: GoalFormProviderProps): React.JSX.Element => {
  const methods = useForm<FieldValues>({
    defaultValues,
  });

  const contextValue = useMemo(
    () => ({ ...methods, loading }),
    [methods, loading]
  );

  return (
    <GoalFormContext.Provider value={contextValue}>
      {children}
    </GoalFormContext.Provider>
  );
};
